import { createSelector } from "@reduxjs/toolkit";

const selectPrefVerificationMethod = (state) =>
  state?.login?.loginTokenValues?.pvm;
const selectEmail = (state) => state?.login?.email;
const selectUserName = (state) => state?.login?.userName;
const selectPhoneNo = (state) => state?.login?.phoneNo;
const selectMockSmsOTP = (state) => state?.login?.mockSmsOTP;
const selectOtpp = (state) => state?.login?.loginTokenValues?.otpp;
const selectOtpe = (state) => state?.login?.loginTokenValues?.otpe;
const selectSendOTPDescription = (state) => state?.login?.sendOTPDescription;
const selectValidateOTPDescription = (state) =>
  state?.login?.validateOTPDescription;
const selectFPACTUserRole = (state) =>
  state?.login?.loginTokenValues?.fpactUserType;

const selectFlow = (state) => state?.login?.flow;
const selectLoginResponseDescription = (state) =>
  state?.login?.loginResponseDescription;
const selectIsUsernameRetrieved = (state) => state?.login?.isUsernameRetrieved;
const selectIsUserVerificationRemembered = (state) =>
  state?.login?.isUserVerificationRemembered;
const selectFlw = (state) => state?.login?.loginTokenValues?.flw;
const selectChangeDescription = (state) =>
  state?.login?.changePrefMethodDescription;
const selectRemoveDescription = (state) =>
  state?.login?.removeVerificationMethodDescription;
const selectAccountDetailsReceived = (state) =>
  state?.login?.accountDetailsReceived;

const selectLnr = (state) => state?.login?.loginTokenValues?.lnr;
const selectLoginToken = (state) => state?.login?.loginToken;
const selectDateOfBirth = (state) => state?.login?.dateOfBirth;
const selectMonthDayOfBirth = (state) => state?.login?.monthDayOfBirth;
const selectToastFlow = (state) => state?.login?.toastFlow;
const selectIsPasswordExpired = (state) => state?.login?.loginTokenValues?.pwe;
const selectIsPasswordChangeFlag = (state) =>
  state?.login?.loginTokenValues?.pwc;
const selectAddEditEmail = (state) => state?.login?.addEditEmail;
const selectAddEditPhone = (state) => state?.login?.addEditPhone;
const selectIsAddEditVerificationFlow = (state) =>
  state?.login?.isAddEditVerificationFlow;

export const manageLoginSelector = createSelector(
  [
    selectPrefVerificationMethod,
    selectEmail,
    selectPhoneNo,
    selectMockSmsOTP,
    selectOtpp,
    selectOtpe,
    selectSendOTPDescription,
    selectValidateOTPDescription,
    selectFPACTUserRole,
    selectFlow,
    selectLoginResponseDescription,
    selectIsUsernameRetrieved,
    selectIsUserVerificationRemembered,
    selectFlw,
    selectUserName,
    selectChangeDescription,
    selectRemoveDescription,
    selectAccountDetailsReceived,
    selectLnr,
    selectLoginToken,
    selectDateOfBirth,
    selectMonthDayOfBirth,
    selectToastFlow,
    selectIsPasswordExpired,
    selectAddEditEmail,
    selectAddEditPhone,
    selectIsPasswordChangeFlag,
    selectIsAddEditVerificationFlow,
  ],
  (
    prefVerificationMethod,
    emailId,
    phoneNo,
    mockSmsOTP,
    otpp,
    otpe,
    sendOTPDescription,
    validateOTPDescription,
    fpactUserRole,
    flow,
    loginResponseDescription,
    isUsernameRetrieved,
    isUserVerificationRemembered,
    flw,
    userName,
    changeDescription,
    removeDescription,
    accountDetailsReceived,
    lnr,
    loginToken,
    dateOfBirth,
    monthDayOfBirth,
    toastFlow,
    isPasswordExpired,
    addEditEmail,
    addEditPhone,
    isPasswordChangeFlag,
    isAddEditVerificationFlow
  ) => ({
    prefVerificationMethod,
    emailId,
    phoneNo,
    mockSmsOTP,
    otpp,
    otpe,
    sendOTPDescription,
    validateOTPDescription,
    fpactUserRole,
    flow,
    loginResponseDescription,
    isUsernameRetrieved,
    isUserVerificationRemembered,
    flw,
    userName,
    changeDescription,
    removeDescription,
    accountDetailsReceived,
    lnr,
    loginToken,
    dateOfBirth,
    monthDayOfBirth,
    toastFlow,
    isPasswordExpired,
    addEditEmail,
    addEditPhone,
    isPasswordChangeFlag,
    isAddEditVerificationFlow,
  })
);
